import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router, UrlTree } from '@angular/router';
import { hasSuperAdminRole } from 'app/shared/utils/super-admin-access.util';

@Injectable({ providedIn: 'root' })
export class SuperAdminGuard implements CanActivate, CanLoad {
    constructor(private readonly router: Router) {}

    canActivate(): boolean | UrlTree {
        return this.checkAccess();
    }

    canLoad(): boolean | UrlTree {
        return this.checkAccess();
    }

    private checkAccess(): boolean | UrlTree {
        if (hasSuperAdminRole()) return true;
        console.warn('[Access denied] SuperAdminGuard', {
            requestedUrl: this.router.getCurrentNavigation()?.extractedUrl?.toString() || this.router.url,
            reason: 'This page requires the SuperAdmin email; adding profile permissions cannot grant access.'
        });
        return this.router.parseUrl('/forbidden-access');
    }
}
